// extracted by mini-css-extract-plugin
export default {"columns":"ParentChildRelationship_columns__gd0f7","column":"ParentChildRelationship_column__fxfU+"};